// THIS IS SAMPLE CODE ONLY - NOT MEANT FOR PRODUCTION USE
import { BlobServiceClient} from '@azure/storage-blob';
import { Route } from '@mui/icons-material';
import Formuser from '../form-user/form';

const sasToken = process.env.storagesastoken || "sv=2021-06-08&ss=b&srt=sco&sp=rwdlaciytfx&se=2022-11-30T19:02:02Z&st=2022-11-09T11:02:02Z&spr=https&sig=2JmJPNqxRkmltt7dPyFd5ej8tUJpCka1qIkVrQvRPzw%3D"; // Fill string with your SAS token
const containerName = `acaa`;
const storageAccountName = process.env.storageresourcename || "sawaacaa"; // Fill string with your Storage resource name

// Feature flag - disable storage feature to app if not configured
export const isStorageConfigured = () => {
  return !((!storageAccountName || !sasToken));
};

// return list of blobs in container to display
const getBlobsInContainer = async (containerClient) => {
  const returnedBlobUrls = [];

  // get list of blobs in container
  // eslint-disable-next-line
  for await (const blob of containerClient.listBlobsFlat()) {
    // if image is public, just construct URL
    returnedBlobUrls.push(
      `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`
    );
  }

  return returnedBlobUrls;
};


const createBlobInContainer = async (containerClient, file) => {
  
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(file.name);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadBrowserData(file, options);
  await blobClient.setMetadata({UserName : 'shubham'});
};

const uploadFileToBlob = async (file) => {
  if (!file) return [];

  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
    
  );
  // get Container - full public read access
  const containerClient = blobService.getContainerClient(containerName);
  console.log(containerClient.url)


  // upload file
  await createBlobInContainer(containerClient, file);
  // get list of blobs in container
  console.log(containerClient.url)
  console.log(file)

  return (containerClient.url);
 };

// </snippet_uploadFileToBlob>

export default uploadFileToBlob;

